import { html } from "/WebInterface/new-ui/assets/js/utils/te.js";

const activityTemplate = html`
  <div
    class="is-flex is-justify-content-space-between is-align-items-start upper-section">
    <div class="is-flex is-align-items-start">
      <b class="text-primaryMain text-sm">${"type"}</b>
      <p class="text-primaryMain text-sm ml-2 subtitle">${"message"}</p>
    </div>
    <button class="primary-button is-bg-none text-sm cancel-button is-hidden">
      <i class="icon-remove"></i>
    </button>
  </div>
  <div
    class="is-flex is-justify-content-space-between is-align-items-center mt-2 lower-section">
    <p class="text-primaryMain text-sm">${"progressTextLeft"}</p>
    <div class="progress-bar is-hidden is-relative">
      <p class="completed-percentage text-primaryMain">
        ${"currentProgressPercentage"}
      </p>
      <progress
        class="progress success-progress"
        value="${"currentProgress"}"
        max="${"maxProgress"}"></progress>
    </div>
    <p class="text-primaryMain text-sm">${"progressTextRight"}</p>
  </div>
`;

const emptyTemplate = html`
  <div class="p-3">
    <p data-i18n-key="${"i18nKey"}" class="text-primaryMain has-text-centered">
      ${"nothingToDisplayText"}
    </p>
  </div>
`;

export default { activityTemplate, emptyTemplate };
